// extracted by mini-css-extract-plugin
module.exports = {"mainBlockContainer":"ContentContainer_mainBlockContainer__2jgLI","mainCreateBlock":"ContentContainer_mainCreateBlock__GEZGd"};